/** @format */
import { AxiosResponse } from 'axios';
import { get } from 'lodash';

export function pageDataSerializer(response: AxiosResponse) {
    const [sectionData, otherData] = Object.keys(response.data.data).reduce(
        (accumulator: any, key: string) => {
            const index = key === 'siteSectionCollection' ? 0 : 1;
            accumulator[index] = get(response, `data.data.${key}.items`);
            return accumulator;
        },
        [[], []]
    );

    return {
        ...sectionData.reduce((obj: any, data: any) => {
            obj[data.key] = data.linkedFrom.entryCollection.items;
            return obj;
        }, {}),
        OTHER: otherData,
    };
}
